<template>
  <vuestic-alert type="danger" class="d-flex" v-if="error">
    <span class="badge badge-pill badge-danger">{{'Error' | translate}}</span>
    <span class="mr-auto text-truncate">{{error.message || error}}</span>
    <a class="text-nowrap" style="margin: 0 .5em;" href="javascript:"
       :title="typeof error === 'object' ? JSON.stringify(error, null, '  ') : error"
       @click="() => {window.console.error(error); window.alert(typeof error === 'object' ? JSON.stringify(error, null, '  ') : error)}">
      {{'Details' | translate}}</a>
  </vuestic-alert>
</template>

<script>
  export default {
    name: 'vuestic-alert-error',
    props: {
      error: {},
    },
    computed: {
      window: () => window,
    },
  };
</script>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-alert-error/VuesticAlertError.vue